import styled, { css } from 'styled-components';
import { hideOverflowText, mediaSize } from '../../../styles';


export const RequestInfo = styled.div` 
  display: grid;
  
  ${({ type }) =>
    type === 'contacts'
      ? css`
        grid-template-columns: minmax(50px, 905px) 175px minmax(50px,225px) 200px 1fr;
        grid-template-areas: 
          "request-subject-wrap request-source-wrap request-status-wrap request-counters-wrap request-date-assignees-wrap";`
      : css`
        grid-template-columns: minmax(50px, 250px) 190px minmax(50px, 650px) minmax(50px,225px) 200px 1fr;
        grid-template-areas: 
          "contacts-wrap request-source-wrap request-subject-wrap request-status-wrap request-counters-wrap request-date-assignees-wrap";
  `}
  
  grid-template-rows: 50px;
  align-items: center;
  width: 100%;
  cursor: ${({ isPointer }) => isPointer ? 'pointer' : 'auto'};
  
  em {
    color: ${props => props.theme.colors.tangerinePrimary};
    font-style: inherit;
    margin-left: 5px;
    justify-self: start;
    place-self: start;
  }
`;

export const HeaderRightSide = styled.div`
  display: flex;
  flex: 0 0 auto;
`;

export const ContactsWrapper = styled.div`
  grid-area: contacts-wrap;

  display: flex;
  max-width: max-content;
  margin-right: 5px;
  padding: 10px
`;

export const ContactName = styled.span`
  ${hideOverflowText};
  width: auto;
  max-width: 170px;
  font-weight: 500;
  cursor: pointer;
  color: ${props => props.theme.colors.mainDark};
`;

export const RequestSourceWrapper = styled.div`
  grid-area: request-source-wrap;

  max-width: 150px;
  width: 100%;
  margin-left: 10px;
`;

export const RequestSource = styled.div`
  padding: 0 15px 1px 15px;
  flex-shrink: 0;
  background-color: ${({ color }) => color};
  color: ${props => props.theme.colors.white};
  width: max-content;
  height: 21px;
  line-height: 21px;
  font-size: 13px;
  text-align: center;
  border-radius: 15px;
  margin-right: 45px;
    
  @media(max-width: ${mediaSize.desktop}) {
    margin-right: 0;
    width: 100px;
  }
  @media(max-width: ${mediaSize.phone}) {
    display: none;
  }
  
  > div {
    max-width: 120px;
    ${hideOverflowText};
  }
`;

export const RequestSubjectWrap = styled.div`
  grid-area: request-subject-wrap;
  
  margin-left: 10px;
  padding-right: 15px;
  ${hideOverflowText};
  color: ${props => props.theme.colors.mainDark};

  position:relative;
  display:inline-block;  
`;

export const RequestStatus = styled.div`
  grid-area: request-status-wrap;

  display: flex;
  font-size: 13px;
  margin-left: 10px;
  font-weight: 500;
  text-align: left;
  color: ${({ color }) => color};
  cursor: ${({ isPointer }) => isPointer ? 'pointer' : 'auto'};
`;

export const RequestStatusTitle = styled.div`
  display: inline-block;
  position: relative;
  padding-right: ${({ needInfo }) => needInfo ? 25 : 0}px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RequestStatusDescription = styled.div`
  max-width: 220px;
  font-weight: 400;
  word-wrap: break-word;
`;

export const RequestLabel = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ color }) => color}
  text-align: center;
  font-size: 12px;
  padding: ${({ isDescription }) => !isDescription ? '3px 6px' : '3px 24px 3px 6px'};
  border-radius: 3px;
  margin: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RequestLabelTitle = styled.span`
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RequestLabelsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: min-content;
  max-width: 300px;
  margin: -3px;
`;

export const RequestDateAndAssigneesWrapper = styled.div`
  grid-area: request-date-assignees-wrap;

  width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  @media(max-width: ${mediaSize.tablet}) {
    display: none;
  }
`;

export const RequestUserAssignees = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${props => props.theme.colors.mainDark};
`;

export const RequestUserAssigneesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: end;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const HiddenAssigneesCounter = styled.span`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.fontSilverLight};
  cursor: pointer;
`;

export const SvgWrapper = styled.span`
  position: absolute;
  top: -2px;
  right: 0;
  padding: 4px;
  height: 19px;
  cursor: pointer;
`;

export const RequestDate = styled.div`
  ${hideOverflowText};
  width: 105px;
  font-size: 10px;
  line-height: 12px;
  text-align: right;
  color: ${({ theme }) => theme.colors.secondaryDark};
`;

export const RequestHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  max-width: 100%;
  margin: 6px;
  
  @media(max-width: ${mediaSize.large}) {
    ${RequestInfo} {
    ${({ type }) =>
    type === 'contacts'
      ? css`
        grid-template-columns: minmax(50px, 500px) minmax(50px,225px) 200px 1fr;
        grid-template-areas: 
          "request-subject-wrap request-status-wrap request-counters-wrap request-date-assignees-wrap";`
      : css`
        grid-template-columns: minmax(50px, 200px) minmax(50px, 500px) minmax(50px,100px) 150px 1fr;
        grid-template-areas: 
          "contacts-wrap request-subject-wrap request-status-wrap request-counters-wrap request-date-assignees-wrap";
        `}
    }

    ${RequestSourceWrapper} {
      display: none;
    }
  }
  
  @media(max-width: ${mediaSize.desktop}) {
    ${RequestInfo} {
    ${({ type }) =>
    type === 'contacts'
      ? css`
        grid-template-columns: minmax(100px,500px) minmax(50px,225px) 190px 1fr;
        grid-template-areas: 
          "request-subject-wrap request-status-wrap request-counters-wrap request-date-assignees-wrap";`
      : css`
        grid-template-columns: minmax(50px, 200px) minmax(50px, 500px) minmax(50px,100px) 150px 1fr;
        grid-template-areas: 
          "contacts-wrap request-subject-wrap request-status-wrap request-counters-wrap request-date-assignees-wrap";
        `}
    }
  }
  
  @media(max-width: ${mediaSize.tablet}) {
    ${RequestInfo} {
    ${({ type }) =>
    type === 'contacts'
      ? css`
        grid-template-columns: minmax(50px,350px) 175px;
        grid-template-areas: 
          "request-subject-wrap request-status-wrap";`
      : css`
        grid-template-columns: minmax(50px,160px) minmax(50px,260px) 175px;
        grid-template-areas: 
          "contacts-wrap request-subject-wrap request-status-wrap";
        `}
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/styled-components.js